import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from "../../components/common/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import {isMobileOnly} from 'react-device-detect';
import { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { reqEsBrandCate2Name, setEsMyBrandCate3StepAction , reqEsBrandStep3, reqEsBrandStep3Add, setEsMySelBrandStep3Action, setEsMyInfoStep4Action} from '../../modules/es/esMyModule';
import { getCateListAction } from '../../modules/common/cateModule';
import { groupBy, forEach, remove, concat, findIndex, replace, find } from 'lodash';
import TagBtnMy from '../../components/common/button/TagBtnMy';
import MyEsBrandItem from '../../components/es/MyEsBrandItem';
import MyEsBrandCatePopup from '../../components/es/MyEsBrandCatePopup';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../../components/common/popup/NormalPopup';
import {Toast, toast, ToastLeft} from '../../components/common/noti/Toast';
import { reqEsItemListIngAction} from '../../modules/es/esItemModule';
import { setEsApplyProdDelAllAction } from '../../modules/es/esApplyModule';
import $ from 'jquery';
import * as CONSTANTS from '../../lib/util/Constants';
import Footer from "../../components/common/Footer";

const EstimateStepBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        //padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};

    .yellow {
        color: #ffc742;
    }

    #siteMoveBtn {
        bottom: ${isMobileOnly? '80px': '110px'};
      }

      
    .step3-brand:first-child {
        margin-top: 5px;
    }
`;

const EstimateStepHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 0 42px 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
        margin-bottom: 30px;
    `};
    position:relative;

    .title-num {
        //width: 100vw;
        height: 50px;
        color: #cccccc;
        font-family: 'Berkshire Swash';
        font-size: 18px;
        line-height: 1.28;
        padding-top: 8px;

        .num-left {
            margin-right: 8px;
            ::after {
                content: '';
                display: inline-block;
                width: 21px;
                height: 4px;
                margin-left: 8px;
                object-fit: contain;
                background: url(/assets/images/icon/arrow_my_title.svg) center center/auto no-repeat;
                vertical-align: 6px;
            }
        }
        .num-right {
            margin-left: 8px;
        }
    }

    .close {
        margin-top: 6px;
        margin-right: -3vw;
        width: 36px;
        height: 36px;
        background: url(/assets/images/icon/btn_delete.png) center center/auto no-repeat;
    }
    
    .title {
        ${isMobileOnly?`
        font-size: 22px;
        line-height: 1.45;
        `:`
        font-size: 24px;
        line-height: 1.5;
        `};
        font-family: NotoSansKR;
        font-weight: bold;
        color: #111111;
    }

    .sub {
        font-size: 12px;
        font-weight: normal;
        font-family: NotoSansKR;
        line-height: 2.17;
        color: #cccccc;
    }
`;

const EstimaateTopCateBlcok = styled.div`
    ${isMobileOnly?`
    width: 100vw;
    margin-left: -4vw;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    `:`
    height: 24px;
    overflow: hidden;
    margin-bottom: 20px;
    `};

    position: relative;

    .container {
        ${isMobileOnly?`
        width: max-content;
        padding-bottom: 15px;
        `:`
        display: flex;
        white-space: nowrap;
        top: 0px;
        position: relative;
        width: max-content;
        `};
    }

    .top-cate {
        margin-right: 6px;
        //margin-bottom: 10px;
        float: left;
    }
    .top-cate:last-child {
        ${isMobileOnly?`
        margin-right: 4vw;
        `:`
            
        `};
    }

    .top-cate:first-child {
        ${isMobileOnly?`
        margin-left: 4vw;
        `:`
            
        `};
    }
    
`;

const EstimaateTopCateArrowBlcok = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ffffff;
    padding-left: 15px;
`;

const EstimaateTopCateArrowLeftBlcok = styled.button`
    width: 26px;
    height: 26px;
    float: left;
    //padding: 25px;
    //margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
`;

const EstimaateTopCateArrowRightBlcok = styled.button`
    width: 26px;
    height: 26px;
    float: left;
    //padding: 25px;
    //margin-top: 28px;
    background : url(${props => props.backgroundimage}) center no-repeat;;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
`;

const EstimateStepContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const EstimateStepBottomBlock = styled.div`
    margin: 0 -4vw; 
    width: 100vw;
    //display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    border-top: solid 1px #cccccc;
    padding: 20px 10px 30px;
    display: ${props => props.display || 'none'};
    background-color: #ffffff;

    .list {
        padding: 0 18px 0 16px;
    }
    .title {
        color: #999999;
        //margin: 0 18px 0 16px;
        width: 96px;
        display: inline-block;
    }
    .desc {
        color: #333333;
    }

    .num {
        font-weight: 600;
    }

    .green {
        //margin: 0 18px 0 16px;
        color: #79b88a;
    }

    .pre {
        border-radius: 4px;
        background-color: #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
    }

    .next {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;
    }
`;

const EstimateStepBlankBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    //height: 112px;
    ${isMobileOnly?`
    height: 112px;
    `:`
    height: 120px;
    `};
`;

const EstimateAddViewBlock = styled.div`
    
    text-align: center;
    ${isMobileOnly?`
    margin-top: 40px;
    `:`
    margin-top: 20px;
    `};
`;

const EstimateAddViewBtnBlock = styled.button`
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    display: ${props => props.display};//inline-block;
    border-radius: 4px;
`;

const EstimatePopContainer = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    `:`
    
    `};
`;

const EstimatePopBgContainer = styled.div`
    ${isMobileOnly?`
    margin-left: -4vw;
    `:`

    `};
    position: fixed;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100vw;
    height: 100vh;
    z-index: 50;
    
    display: none;
    bottom: 0;
`;

const EstimateStepContentsPCBlock = styled.div`
    width: 1176px;
    margin: 0 auto;
    margin-top: 80px;
    position: relative;
    min-height: 707px;
    
    .left_con {
        width: 720px;
        //height: 707px;
        float: left;
        position: relative;
        padding: 40px 40px 40px 40px;
        border-radius: 10px;
        border: solid 1px #666666;
        margin-left: 40px;
        ::after {
            content: '';
            display: inline-block;
            width: 48px;
            height: 50px;
            background: url(/assets/images/icon/clip.png) center center/auto no-repeat;
            position: absolute;
            background-size: 48px 50px;
            top: -27px;
            right: 33px;
        }
    }

    .right_con {
        width: 355px;
        float: left;
        margin-left: 20px;
        position: relative;
        height: 707px;

        .step_container {
            max-height: 360px;
            -webkit-overflow-scrolling: touch;
            overflow: auto;
            
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            line-height: 2;
            color: #333333;
            margin-bottom: 15px;
            line-height: 1.2;
        }

        .step {
            font-size: 20px;
            font-weight: 500;
            color: #111111;
            line-height: 1.2;

            .five {
                font-weight: normal;
                color: #999999;
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background-color: #cccccc;
        }

        .sub_title {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #999999;
            padding-left: 20px;
        }

        .sub_content {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            color: #333333;
            margin-top: 8px;
            padding: 0 20px;
        }

        .bottom {
            position: absolute;
            bottom: 0;
            width: 100%;
        }
        .next {
            border-radius: 4px;
            background-color: #111111;
            text-align: center;
            color: #ffffff;
            height: 52px;
            width: 100%;
            
        }
        .pre {
            border-radius: 4px;
            //background-color: #ececec;
            text-align: center;
            color: #333333;
            height: 52px;
            width: 100%;
            float: left;
            border: solid 1px #cccccc;
            background-color: #ffffff;
        }
    }
`;

const MAX_CNT = CONSTANTS.MAX_RQST_CNT;
const CATE_HEIGHT = 24;
const CATE_SLIDE_WIDTH = 450;
const EstimateStep3 = () => {

    const dispatch = useDispatch();
    const refContainer = useRef(null);
    const history = useHistory();
    const [cateItems, setCateItems] = useState([]); //id + name + on
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });
    const [selBrand, setSelBrand] = useState([]);
    const [popup, setPopup] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [availCnt, setAvailCnt] = useState(10);
    const [txtES, setTxtES] = useState(-1);
    const [arrCateName, setArrCateName] = useState([]);
    const refCateContainer = useRef(null);
    const refCateContainer2 = useRef(null);
    const refArrow = useRef(null);
    const [leftArrow, setLeftArrow] = useState(false);
    const [rightArrow, setRightArrow] = useState(true);
    const refRightCon = useRef(null);
    const refLeftCon = useRef(null);
    const refBottom = useRef(null);
    const [fixWing, setFixWing] = useState(true);
    const refRightBottom = useRef(null);

    const { categoryItems, error ,esMyBrandCate1Step, esBrandMyStep1, esCate2Name, esMyBrandCate3Step, esBrandMyStep3, esSelBrandStep3, accessToken, esItems, esMyBudget} = useSelector(
        ({ cateItemsReducer, esMyReducer, userReducer, esItemsReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            esMyBrandCate1Step: esMyReducer.esMyBrandCate1Step,
            esBrandMyStep1: esMyReducer.esBrandMyStep1,
            esCate2Name: esMyReducer.esCate2Name,
            esMyBrandCate3Step: esMyReducer.esMyBrandCate3Step,
            esBrandMyStep3:esMyReducer.esBrandMyStep3,
            esSelBrandStep3: esMyReducer.esSelBrandStep3,
            accessToken: userReducer.accessToken,
            esItems: esItemsReducer.esItems,
            esMyBudget: esMyReducer.esMyBudget,
        })
    );


    // 최소 실행시 Header 관련 처리 추가  
    useEffect(() => {
        dispatch(setCurMenuAction('esapply'));
        dispatch(setHeaderTransferAction(false));

        //console.log("history = " + JSON.stringify(history));
        //console.log("esSelBrandStep3 = " + JSON.stringify(esSelBrandStep3));
        if(history.action !== 'POP'){
            let data = [];
            dispatch(setEsMySelBrandStep3Action(data));
            let store = {}
            //selCateId,arrFilter,cateid,curPrice[0],curPrice[1],brandId,curPage,order
            dispatch(setEsMyInfoStep4Action(store));
        } else {
            if(esSelBrandStep3) {
                //console.log("esSelBrandStep3 = " + JSON.stringify(esSelBrandStep3));
                let checkInfo = [];
                Object.assign(checkInfo, esSelBrandStep3);
                setSelBrand(checkInfo);
            }
        }

        //4단계 초기화
        dispatch(setEsApplyProdDelAllAction());

        if(esMyBudget <= 0) {
            history.goBack();
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if(!isMobileOnly&&refRightBottom&&refRightBottom.current) {
            setTimeout(() => {
                if(refRightBottom&&refRightBottom.current)
                refRightBottom.current.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, [refRightBottom]);

    useEffect(() => {
        if(!isMobileOnly) {
            window.addEventListener("resize", onScroll);
        }
        
        return () => {
            if(!isMobileOnly) {
                window.removeEventListener("resize", onScroll)};
            }
    }, []);

    const onScroll = () => {
        var nowScroll = $(window).scrollTop();
        //console.log("window.scrollY = " + window.scrollY);
        //console.log("documentElement.scrollY = " + document.documentElement.scrollTop);
        if(!isMobileOnly&&refRightCon && refRightCon.current) {

            if (refBottom.current) {
                if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < refBottom.current.offsetTop - 890) {
                    setFixWing(true);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        const wing = refRightCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset = " + offset);
                        $(wing).css('left', offset + 720);
    
                    }
                }
                else {
                    setFixWing(false);
                    if (refRightCon.current && refLeftCon.current) {
                        const product = refLeftCon.current;
                        var offset = $(product).offset().left;
                        //console.log("offset22 = " + offset);

                        const wing = refRightCon.current;
                        $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);
    
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (refBottom.current) {
            //console.log("window.scrollY = " + window.scrollY);
            //console.log("documentElement.scrollY = " + document.documentElement.scrollTop);
            if (document.documentElement.scrollTop < 80 || document.documentElement.scrollTop < (refBottom.current.offsetTop)) {
                setFixWing(true);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    const wing = refRightCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset33 = " + offset);
                    $(wing).css('left', offset + 720);

                }
            }
            else {
                setFixWing(false);
                if (refRightCon.current && refLeftCon.current) {
                    const product = refLeftCon.current;
                    var offset = $(product).offset().left;
                    //console.log("offset44 = " + offset);

                    const wing = refRightCon.current;
                    $(wing).css('left', refLeftCon.current.getBoundingClientRect().width + 40);

                }
            }
        }

    }, [refRightCon.current, refLeftCon.current, refBottom.current]);

    /* useEffect(() => {
        if(esCate2Name === null) {
            //dispatch(reqEsBrandCate2Name());
        }
    }, [esCate2Name]); */

    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {
            let arr = [];
            forEach(categoryItems, (curobj, index) => {
                let cate1Id = curobj.id;
                forEach(curobj.cate2, (cate2, index) => {
                    let cateid = cate1Id*100 + cate2.id*1;
                    let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                    arr.push(cateItem);
                });
            });
            
            if(esMyBrandCate3Step && esMyBrandCate3Step.length > 0) {
                forEach(arr, (cate, index) => {
                    let idx = findIndex(esMyBrandCate3Step, (curitem) => {
                        //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                        return curitem*1 === cate.id*1;
                    })
    
                    if(idx >= 0) {
                        cate.on = true;
                    } else {
                        cate.on = false;
                    }
                });
    
                //console.log("arr22 = " + JSON.stringify(arr));
                setCateItems(arr);
    
                if(esMyBrandCate3Step ) {
                    dispatch(reqEsBrandStep3(esMyBrandCate3Step, 0));
                }
            } else if(esMyBrandCate1Step){
                if(esMyBrandCate1Step) {
                    forEach(arr, (cate, index) => {
                        let idx = findIndex(esMyBrandCate1Step, (curitem) => {
                            //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                            return curitem*1 === cate.id*1;
                        })
        
                        if(idx >= 0) {
                            cate.on = true;
                        }  else {
                            cate.on = false;
                        }
                        
                    });
                }
    
                //console.log("setEsMyBrandCate3StepAction = ");
                //console.log("esMyBrandCate1Step = " + JSON.stringify(esMyBrandCate1Step));
                setCateItems(arr);
                dispatch(setEsMyBrandCate3StepAction(esMyBrandCate1Step));
            }
            
            if(!isMobileOnly&&refRightBottom&&refRightBottom.current) {
                setTimeout(() => {
                    refRightBottom.current.scrollIntoView({ behavior: 'smooth' });
                }, 500);
            }
        }

    }, [categoryItems]);

    useEffect(() => {
        //console.log("esMyBrandCate3Step = " + JSON.stringify(esMyBrandCate3Step));

        //console.log("cateItems = " + JSON.stringify(cateItems));
        

        if(esMyBrandCate3Step && cateItems.length > 0) {
            let arr = [];
            Object.assign(arr, cateItems);

            forEach(arr, (cate, index) => {
                let idx = findIndex(esMyBrandCate3Step, (curitem) => {
                    //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                    return curitem*1 === cate.id*1;
                })

                if(idx >= 0) {
                    cate.on = true;
                } else {
                    cate.on = false;
                }
            });

            //console.log("arr22 = " + JSON.stringify(arr));
            setCateItems(arr);

            if(esMyBrandCate3Step ) {
                //console.log("esMyBrandCate3Step = " + JSON.stringify(esMyBrandCate3Step));
                dispatch(reqEsBrandStep3(esMyBrandCate3Step, 0));
                
                //let checkInfo = [];
                //setSelBrand(checkInfo);
            }

        } else if(esMyBrandCate3Step && cateItems.length === 0 && categoryItems) {
            let arr = [];
            forEach(categoryItems, (curobj, index) => {
                let cate1Id = curobj.id;
                forEach(curobj.cate2, (cate2, index) => {
                    let cateid = cate1Id*100 + cate2.id*1;
                    let cateItem = {id:cateid, name:cate2.cate_name, on:false};
                    arr.push(cateItem);
                });
            });

            forEach(arr, (cate, index) => {
                let idx = findIndex(esMyBrandCate3Step, (curitem) => {
                    //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                    return curitem*1 === cate.id*1;
                })

                if(idx >= 0) {
                    cate.on = true;
                } else {
                    cate.on = false;
                }
            });

            //console.log("arr22 = " + JSON.stringify(arr));
            setCateItems(arr);

            /* if(esMyBrandCate3Step ) {
                console.log("reqEsBrandStep3 2222 " );
                //dispatch(reqEsBrandStep3(esMyBrandCate3Step, 0));
                let checkInfo = [];
                //setSelBrand(checkInfo);
            } */

        }
        
    }, [esMyBrandCate3Step]);

    useEffect(() => {
        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }
        
        setScrollPostion({ heignt: 0, isClick: false });
        onScroll();
    }, [esBrandMyStep3]);

    useEffect(() => {
        if(esBrandMyStep1 === null) {
            history.replace('/estimate/step1');
        }
    }, [esBrandMyStep1]);

    useEffect(() => {
        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
            try {
                
                setTxtES(cnt);
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                    let msg = cnt;
                    setTxtES(msg);

                    if(cnt*1 === 0) {
                        let msg = "나의 견적 횟수를 모두 사용했어요 😭 \n견적서를 정리할 수 있도록 견적체크 페이지로 이동합니다."
                        toast('SUCCESS', msg);
                        setTimeout(() => {
                            //history.replace('/es');
                            history.replace("/es",{ index: 0 })
                        }, 2000);
                    } else {
                        let msg = "보고싶은 브랜드를 최대 "+cnt+"개 선택해주세요🙂"
                        toast('SUCCESS', msg);
                    }
                } 

            } catch (e) { }

        } else {
            dispatch(reqEsItemListIngAction());// 견적정보 get
            if(accessToken) {

            } else {
                let msg = "보고싶은 브랜드를 최대 10개 선택해주세요🙂"
                toast('SUCCESS', msg);
            }
        }

    }, [esItems, accessToken])

    useEffect(() => {
        if(!isMobileOnly&&refCateContainer&&refCateContainer.current) {
            let height = refCateContainer.current.getBoundingClientRect().height;

            if(refCateContainer.current.getBoundingClientRect())
            //console.log("rec = " + JSON.stringify(refCateContainer.current.getBoundingClientRect()))
            //console.log("offsetTop = " + JSON.stringify(refCateContainer.current.offsetTop))
            //console.log("height = " + JSON.stringify(refCateContainer.current.offsetHeight))
            //console.log("height = " + JSON.stringify($('#cateContainer').height()))
            //console.log("top = " + JSON.stringify($('#cateContainer').position()))
            //$('#cateContainer').height;

            //refCateContainer.current.style.top = refCateContainer.current.offsetTop - 24 + 'px';
            //console.log("width = " + refCateContainer.current.getBoundingClientRect().width)
            //console.log("width2 = " + refCateContainer2.current.getBoundingClientRect().width)
            if(refCateContainer.current.getBoundingClientRect().width > refCateContainer2.current.getBoundingClientRect().width) {
                refArrow.current.style.display = "block";
                let left = refCateContainer.current.offsetLeft;
                //console.log("left = " + left)
                if(left*-1 > CATE_SLIDE_WIDTH && left*-1 + refCateContainer2.current.getBoundingClientRect().width -52 - CATE_SLIDE_WIDTH> refCateContainer.current.getBoundingClientRect().width) {
                    refCateContainer.current.style.left = left + CATE_SLIDE_WIDTH + 'px';
                }
            } else {
                refArrow.current.style.display = "none";
                refCateContainer.current.style.left = '0px';
            }

            handleArrow(refCateContainer.current.offsetLeft);
            /* if(refCateContainer.current.offsetHeight >= CATE_HEIGHT*2) {
                //console.log("offsetWidth = " + JSON.stringify(refCateContainer.current.offsetWidth))
                refCateContainer.current.style.width = refCateContainer2.current.offsetWidth - 42 + 'px';
                refArrow.current.style.display = "block";
            } else {
                refCateContainer.current.style.width = refCateContainer2.current.offsetWidth;
                refArrow.current.style.display = "none";
                refArrow.current.style.display = "block";
            }

            if(refCateContainer.current.offsetTop*-1 >= refCateContainer.current.offsetHeight) {
                let top = refCateContainer.current.offsetTop;
                //console.log("top = " + top)
                if(top < 0) {
                    refCateContainer.current.style.top = top + CATE_HEIGHT + 'px';
                }
                
            } 

            handleArrow(refCateContainer.current.offsetTop);
            */
        }
    }, [cateItems]);

    const handleLeftSlider = () => {
        //console.log("handleLeftSlider")
        if(refCateContainer && refCateContainer.current) {
            let left = refCateContainer.current.offsetLeft;
            //console.log("left = " + left)
            if(left >= 0) {
                refCateContainer.current.style.left = '0px';
                handleArrow(0);
            } else {
                refCateContainer.current.style.left = left + CATE_SLIDE_WIDTH + 'px';
                handleArrow(left + CATE_SLIDE_WIDTH );
            }
  
        }
        /* if(refCateContainer && refCateContainer.current) {
            let top = refCateContainer.current.offsetTop;
            //console.log("top = " + top)
            if(top === 0) {
                handleArrow(0);
            } else {
                refCateContainer.current.style.top = top + CATE_HEIGHT + 'px';
                
                handleArrow(top + CATE_HEIGHT );
            }
        } */
    }
    
    const handleRightSlider = () => {
        //console.log("handleRightSlider")
        if(refCateContainer && refCateContainer.current) {
            let left = refCateContainer.current.offsetLeft;
            //console.log("left = " + left)
            if(left*-1 + CATE_SLIDE_WIDTH >= refCateContainer.current.getBoundingClientRect().width 
            || left*-1 + refCateContainer2.current.getBoundingClientRect().width >= refCateContainer.current.getBoundingClientRect().width) {
                handleArrow(left);
            } else {
                refCateContainer.current.style.left = left - CATE_SLIDE_WIDTH + 'px';
                handleArrow(left - CATE_SLIDE_WIDTH);
            }
 
        }
        /* if(refCateContainer && refCateContainer.current) {
            let top = refCateContainer.current.offsetTop;
            //console.log("top = " + top)
            if(top*-1 + CATE_HEIGHT >= refCateContainer.current.offsetHeight) {
                handleArrow(top);
            } else {
                refCateContainer.current.style.top = top - CATE_HEIGHT + 'px';
                
                handleArrow(top - CATE_HEIGHT);
            }
        } */
    }

    const handleArrow = (top) => {
        //console.log("left = " + top)
        //console.log("width = " + refCateContainer.current.getBoundingClientRect().width)
        if(top === 0) {
            setLeftArrow(false);
            setRightArrow(true);
        } else if(top*-1 + CATE_SLIDE_WIDTH >= refCateContainer.current.getBoundingClientRect().width) {
            setLeftArrow(true);
            setRightArrow(false);
        } else if(top*-1 + refCateContainer2.current.getBoundingClientRect().width >= refCateContainer.current.getBoundingClientRect().width) {
            setLeftArrow(true);
            setRightArrow(false);
        } else {
            setLeftArrow(true);
            setRightArrow(true);
        }

        /* if(top === 0) {
            setLeftArrow(false);
            setRightArrow(true);
        } else if(top*-1 + CATE_HEIGHT === refCateContainer.current.offsetHeight) {
            setLeftArrow(true);
            setRightArrow(false);
        } else {
            setLeftArrow(true);
            setRightArrow(true);
        } */
    }

    //#2611 top 버튼 처리
    const handleTopClick = () => {
        //window.scrollTo({ top: 200, behavior: 'smooth' });
        $('html, body').stop().animate({
            scrollTop: 0
        }, 500, 'swing');
    }

    const handleOnBrand = (myBrandCate3Step) => {
        let arr = [];
        Object.assign(arr, cateItems);

        let arrCateName = [];
        forEach(arr, (cate, index) => {
            let idx = findIndex(myBrandCate3Step, (curitem) => {
                //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
                return curitem*1 === cate.id*1;
            })

            if(idx >= 0) {
                
                arrCateName.push(cate.id);
            } else {
                
            }
        });

        //console.log("arrCateName = " + JSON.stringify(arrCateName));
        let checkInfo = [];
        Object.assign(checkInfo, selBrand);

        forEach(selBrand, (brand, index) => {
            //console.log("brand = " + JSON.stringify(brand))
            let value = false;
            for(let i = 0; i < arrCateName.length; i++) {
                let idx = brand.cateString.indexOf(arrCateName[i]);
                
                if (idx >= 0) {
                    value = true;
                    break;
                }
            }

            if(value === false) {
                remove(checkInfo, (obj) => {
                    return (obj.brnd_id*1 === brand.brnd_id*1);
                });
            }

        });

        setSelBrand(checkInfo);
    }

    const handleCateClick = (cateid) => {
        let value = true;
        setPopup(value)
    }

    const handleClosePopup = () => {
        setPopup(false)
    }

    const handleCateDelClick = (cateid) => {
        let cate = [];
        Object.assign(cate, esMyBrandCate3Step);
        if(cate.length > 1) {
            remove(cate, (obj) => {
                return (obj*1 === cateid*1);
            });
    
            dispatch(setEsMyBrandCate3StepAction(cate));
            handleOnBrand(cate);
        }

    }

    const handleSelBrand = (brandid, brnd_han, cateString) => {
        if(selBrand === null ) {
            return;
        }

        let idx = findIndex(selBrand, (curitem) => {
            return curitem.brnd_id*1 === brandid*1;
        })

        let checkInfo = [];
        Object.assign(checkInfo, selBrand);

        if(idx >= 0) {
            
            remove(checkInfo, (obj) => {
                return (obj.brnd_id*1 === brandid*1);
            });

        } else {
            if(availCnt > checkInfo.length) {
                let brndinfo = {brnd_id:brandid, brnd_han:brnd_han, cateString:cateString}
                checkInfo.push(brndinfo);
                let msg = '';
                if(checkInfo.length === availCnt) {
                    msg = "보고싶은 브랜드를 모두 선택하셨어요 🙂\n[ 다음 ]을 클릭해주세요";
                } else {
                    msg = checkInfo.length +"개 브랜드를 선택하셨어요 🙂";
                }
                
                toast('SUCCESS', msg);
            }

        }
        setSelBrand(checkInfo);
    }

    const handleCategoryFromPopup = (arrCate) => {
        dispatch(setEsMyBrandCate3StepAction(arrCate));
        handleOnBrand(arrCate);
    }

    const handlePre = () => {
        //history.goBack();
        setOpenModal(true);
    }

    const handleNext = () => {
        //console.log("selBrand = " + JSON.stringify(selBrand))
        if(selBrand && selBrand.length > 0) {
            dispatch(setEsMySelBrandStep3Action(selBrand));
            //dispatch(setEsMyBudgetAction(price));
            history.push("/estimate/step4");
        } else {
            let msg = "브랜드를 선택해주세요 🙂";
            toast('SUCCESS', msg);
        }
       
    }

    const isMoreBtnShow = () => {
        if (esBrandMyStep3 === null ||
            esBrandMyStep3 === undefined ||
            esBrandMyStep3.length === 0 ) {
            return false;
        }
        else if(esBrandMyStep3.length > 0 && esBrandMyStep3[0].brnum > esBrandMyStep3.length){
            return true;
        }

        return false;
    }

    const onClickAddView = () => {
        dispatch(reqEsBrandStep3Add(esMyBrandCate3Step, esBrandMyStep3.length));
        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const handleModalBtn1Click = () => {
        let check=[];
        dispatch(setEsMySelBrandStep3Action(check));
        setOpenModal(false);
        history.goBack();
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const getPopup = () => {
        let msg = "해당 Step에서 입력한 모든 내용이\n초기화 됩니다";
        return (<NormalPopup
            text={""}
            text2={msg}
            text3={""}
            btn1="뒤로가기" btn2="취소"
            onClick1={handleModalBtn1Click}
            onClick2={handleModalBtn2Click} />)

    }

    const getPopupStyle = () => {
        return customModalStyles;
    }

    const getPrice = () => {
        if(esMyBudget === 0) {
            return "";
        } else {
            return Number(esMyBudget.toFixed(1)).toLocaleString() + "원"
        }

    }

    const getCate2Name = () => {
        let txtCate2 = "";
        cateItems.map((cateitem,index) => {
            const cateid = cateitem.id;
            const name = cateitem.name;
            if(cateitem.on) {
                if(txtCate2.length === 0) {
                    txtCate2 = name + "";
                } else {
                    txtCate2 = txtCate2 + ", "+name;
                }
            }
            
        })

        return txtCate2;
    }

    const getBrandName = () => {
        let txtBrand = "";
        selBrand.map((brand,index) => {
            const name = brand.brnd_han;
            if(txtBrand.length === 0) {
                txtBrand = name + "";
            } else {
                txtBrand = txtBrand + ", "+name;
            }
        })

        return txtBrand;
    }

    const setEsBoxPosition = (fixWing) => {
        let style = fixWing ? { position: 'fixed', left: '772px',bottom: 'auto'/* , bottom: 'auto', marginTop: '30px' */ } : { position: 'absolute', left: '772px', bottom: '0px'/* , bottom: '100px', marginTop: '30px' */ }
        return isMobileOnly ? { marginTop: '30px' } : style;
    }

    const getArrowImage = (index) => {
        if(refCateContainer&&refCateContainer.current){
            let top = refCateContainer.current.offsetTop;
            console.log("getArrowImage index = " + index)
            console.log("getArrowImage top = " + top)
            if(index === 1) {  
                if(top === 0) {
                    return '/assets/images/icon/arrow_left_dim.svg';
                } else {
                    return '/assets/images/icon/arrow_left.svg';
                }
            } else {
                if(top*-1 + CATE_HEIGHT >= refCateContainer.current.offsetHeight) {
                    return '/assets/images/icon/arrow_left_dim.svg';
                }
                else {
                    return '/assets/images/icon/arrow_left.svg';
                }
            }
        }
        return '/assets/images/icon/arrow_left.svg';
    }
    return (isMobileOnly?
        <EstimateStepBlock>
                {/* <Header /> */}
                <EstimateStepHeaderBlock className="clearfix">
                    <div className="clearfix">
                    <div className="title-num f-left"><span className="num-left">3</span><span>5</span></div>{/* <div className="close f-right"></div> */}
                    </div>
                    <div className="title"><p><span className="yellow">원하는 브랜드</span>를</p><p>선택해주세요!</p></div>
                    {/* <div className="sub">나만의 가구 견적 알아보기</div> */}

                </EstimateStepHeaderBlock>
                <EstimaateTopCateBlcok>
                    <div className="container clearfix">
                    {
                        cateItems.map((cateitem,index) => {
                                const cateid = cateitem.id;
                                const name = cateitem.name;
                                if(cateitem.on) {
                                    return (
                                        <div key={cateid} className="top-cate">
                                            <TagBtnMy
                                                active={true}
                                                float='left'
                                                onClick={handleCateClick}
                                                onDelClick={handleCateDelClick}
                                                text={name} isSmall={true} value={cateid}
                                            />
                                        </div>
                                    );
                                }
                                
                            })
                        }
                    </div>
                </EstimaateTopCateBlcok>
                <EstimateStepContentsBlock ref={refContainer}>
                {
                    esBrandMyStep3&&esBrandMyStep3.length>0&&esBrandMyStep3.map((brand,index) => {
                        return (<MyEsBrandItem key={brand.brand.brnd_id} info={brand} selBrand={selBrand} handleSelBrand={handleSelBrand} availCnt={availCnt}/>);
                    })
                }
                
                </EstimateStepContentsBlock>
                {isMoreBtnShow() ?
                    <EstimateAddViewBlock>
                    <EstimateAddViewBtnBlock onClick={onClickAddView}>
                        더보기
                    </EstimateAddViewBtnBlock>
                    </EstimateAddViewBlock>:""
                }
                <EstimateStepBlankBlock >&nbsp;</EstimateStepBlankBlock>
            <EstimateStepBottomBlock display={esMyBrandCate1Step&&esMyBrandCate1Step.length>0? "block":"none"}>
                {/* <div className="list margin_b-10"><span className="title">총 예상 금액</span><span className="num">{esBrandMyStep1&&esBrandMyStep1.min&&Number(esBrandMyStep1.min.toFixed(1)).toLocaleString()}</span>원 ~ 
                <span className="num"> {esBrandMyStep1&&esBrandMyStep1.max&&Number(esBrandMyStep1.max.toFixed(1)).toLocaleString()}</span><span>원</span></div>
                <div className="list margin_b-20"><div className="green">*품목별 수량이 1개일 경우의 예상 범위 금액입니다.</div></div> */}
                <button className="pre" onClick={handlePre}>이전</button><button className="next" onClick={handleNext}>다음</button>
            </EstimateStepBottomBlock>
            <EstimatePopBgContainer style={{display:popup? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsBrandCatePopup active={popup} handleClosePopup={handleClosePopup} cate3Step={esMyBrandCate3Step} handleCategory={handleCategoryFromPopup}/>
            </EstimatePopContainer>
            {/* {isMobileOnly? 
            <div id="siteMoveBtn" style={{display: "none"}}>
                <button type="button" className="top" onClick={handleTopClick}></button>
            </div>
            :
             ""
            } */}
            <Toast bottom={"30px"}/>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
        </EstimateStepBlock>
        :
        <EstimateStepBlock>
                <Header />
                <EstimateStepContentsPCBlock className="clearfix">
                    <div className="left_con clearfix" ref={refLeftCon}>
                        <EstimateStepHeaderBlock className="clearfix">
                            <div className="title"><p><span className="yellow">원하는 브랜드</span>를 선택해주세요!</p></div>
                        </EstimateStepHeaderBlock>

                        <EstimaateTopCateBlcok ref={refCateContainer2}>
                            <div className="container clearfix" ref={refCateContainer} id="cateContainer">
                            {
                                cateItems.map((cateitem,index) => {
                                        const cateid = cateitem.id;
                                        const name = cateitem.name;
                                        if(cateitem.on) {
                                            return (
                                                <div key={cateid} className="top-cate">
                                                    <TagBtnMy
                                                        active={true}
                                                        float='left'
                                                        onClick={handleCateClick}
                                                        onDelClick={handleCateDelClick}
                                                        text={name} isSmall={true} value={cateid}
                                                    />
                                                </div>
                                            );
                                        }
                                        
                                    })
                                }
                            </div>
                            <EstimaateTopCateArrowBlcok className="btn_arrow" ref={refArrow}>
                                <EstimaateTopCateArrowLeftBlcok className="btn_left" backgroundimage={leftArrow?'/assets/images/icon/arrow_left.svg':'/assets/images/icon/arrow_left_dim.svg'} onClick={handleLeftSlider}/>
                                <EstimaateTopCateArrowRightBlcok className="btn_right" backgroundimage={rightArrow?'/assets/images/icon/arrow_left.svg':'/assets/images/icon/arrow_left_dim.svg'} onClick={handleRightSlider}/>
                            </EstimaateTopCateArrowBlcok>
                        </EstimaateTopCateBlcok>
                        <EstimateStepContentsBlock ref={refContainer}>
                        {
                            esBrandMyStep3&&esBrandMyStep3.length>0&&esBrandMyStep3.map((brand,index) => {
                                return (<MyEsBrandItem key={brand.brand.brnd_id} info={brand} selBrand={selBrand} handleSelBrand={handleSelBrand} availCnt={availCnt}/>);
                            })
                        }
                        
                        </EstimateStepContentsBlock>
                        {isMoreBtnShow() ?
                            <EstimateAddViewBlock>
                            <EstimateAddViewBtnBlock onClick={onClickAddView}>
                                더보기
                            </EstimateAddViewBtnBlock>
                            </EstimateAddViewBlock>:""
                        }
                    </div>
                    <div className="right_con clearfix" ref={refRightCon} style={setEsBoxPosition(fixWing)}>
                        <div className="title">나만의 상품 견적 알아보기</div>
                        <div className="step margin_b-40"><span>Step 3 </span><span className="five">/ 5</span></div>
                        <div className="line" />
                        <div className="step_container small_scroll">
                            <div className="sub_title margin_t-20">1. 카테고리</div>
                            <div className="sub_content margin_b-20">{getCate2Name()}</div>
                            <div className="sub_title">2. 예산</div>
                            <div className="sub_content margin_b-20">{getPrice()}</div>
                            <div className="sub_title">3. 브랜드</div>
                            <div className="sub_content margin_b-20">{getBrandName()}</div>
                            <div style={{height:'1px'}} ref={refRightBottom}></div>
                        </div>
                        <div className="line" />
                        <div className="bottom">
                            <button className="next margin_b-10" onClick={handleNext}>다음</button>
                            <button className="pre" onClick={handlePre}>이전</button>
                        </div>
                    </div>
                </EstimateStepContentsPCBlock>
                
                <EstimateStepBlankBlock ref={refBottom}>&nbsp;</EstimateStepBlankBlock>
            
            <EstimatePopBgContainer style={{display:popup? "block":'none'}}/>
            <EstimatePopContainer>
                <MyEsBrandCatePopup active={popup} handleClosePopup={handleClosePopup} cate3Step={esMyBrandCate3Step} handleCategory={handleCategoryFromPopup}/>
            </EstimatePopContainer>
            {/* {isMobileOnly? 
            <div id="siteMoveBtn" style={{display: "none"}}>
                <button type="button" className="top" onClick={handleTopClick}></button>
            </div>
            :
             ""
            } */}
            <ToastLeft bottom={"0px"}/>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}
            </Modal>
            <Footer siteMovePosition={isMobileOnly?'80px':'50px'} />
        </EstimateStepBlock>
    );
};

export default EstimateStep3;
